<template>
  <div class="interier-section">
    <div class="interier-section__title">{{ $t('interior') }}</div>
    <div class="interier-section__body">
      <div class="page-py pb-41">
        <div class="container column justify-evenly">
          <div class="section_1">
            <div class="section_1__wrp">
              <ui-tabs
                :is-select-in-mobile="true"
                :anchor="anchor"
                type="simple"
                @changed="setActiveSliderItemMain"
              >
                <ui-tab
                  v-for="project in galleryRealtList"
                  :key="project.name"
                  :name="project.name"
                >
                  <ui-tabs
                    type="simple"
                    @changed="setActiveSliderItem"
                  >
                    <ui-tab :name="$t('images')"> </ui-tab>
                    <ui-tab :name="$t('videoFlyThroughs')"> </ui-tab>
                    <ui-tab :name="$t('tour3D')"> </ui-tab>
                  </ui-tabs>
                </ui-tab>
              </ui-tabs>
            </div>
            <UiSlider
              :items="activeGalleryItem"
              :posters="itemsPoster"
              :typeItems="acitveTypeItems"
              :isReload="isNeedLoad"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {ref} from 'vue';
import {Swiper, SwiperSlide} from 'swiper/vue';
import {FreeMode, Navigation, Thumbs} from 'swiper';
import UiTab from '~/components/Ui/Tabs/UiTab.vue';
import {useRuntimeConfig} from '#imports';
import {useStaticStore} from '~/store/static.store';

const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.vueAppBaseUrl;
const {galleryRealtList} = useStaticStore();

const activeGalleryItem = ref<string[][] | string[] | string>(
  galleryRealtList[0].images,
);
const itemsPoster = ref<{videoSrc: string; value: string}[]>([]);
let activeIndexMain = 0;
let acitveTypeItems = ref('images');
let isNeedLoad = ref(false);

const setActiveSliderItem = (select: {
  tab: {
    computedId: 'video-fly-throughs' | 'images' | '3d-tour';
    index: number;
  };
}) => {
  if (select.tab.index === 1) {
    acitveTypeItems.value = 'video';
    activeGalleryItem.value = galleryRealtList[activeIndexMain].video;
    itemsPoster.value = galleryRealtList[activeIndexMain].poster;
  } else if (select.tab.index === 0) {
    acitveTypeItems.value = 'images';
    activeGalleryItem.value =
      galleryRealtList[activeIndexMain].images;
  } else {
    acitveTypeItems.value = 'tour';
    activeGalleryItem.value = galleryRealtList[activeIndexMain].tour;
  }
};

const setActiveSliderItemMain = (select: {tab: {index: number}}) => {
  isNeedLoad.value = true;
  activeIndexMain = select.tab.index;
  activeGalleryItem.value =
    galleryRealtList[select.tab.index]['images'];
  setTimeout(() => {
    isNeedLoad.value = false;
  }, 0);
};

const route = useRoute();
const anchor = ref();

const slideImg = ref(1);
const slideVideo = ref(1);
const thumbsSwiper = ref({
  video: null,
  image: null,
});

const setThumbsSwiper = (swiper: any, type: 'video' | 'image') => {
  thumbsSwiper.value[type] = swiper;
};

onBeforeMount(() => {
  anchor.value = route.fullPath.split('=')[1];
});
</script>

<style lang="scss">
.interier-section {
  .wrapper {
    .carousel {
      max-width: 850px;
    }
  }
  &__title {
    @include title-fw-700-fs-36-black-100;
  }

  &__body {
    .gallery-swiper {
      height: 100%;
      width: 80%;
      @media (max-width: 1024px) {
        width: 100%;
        height: 500px;
      }
    }
    .pb-41 {
      padding-bottom: 41px;
    }

    .gallery-swiper--thumb {
      box-sizing: border-box;
      height: 100%;
      width: 20%;
      @media (max-width: 1024px) {
        width: 100%;
        height: 200px;
      }
    }

    .section_1 {
      text-align: var(--var-text-align-left);
      width: 100%;

      &__wrp {
        width: 100%;

        .wrapper {
          .carousel {
            max-width: 850px;
          }
        }
      }

      .swiper {
        width: 100%;
        height: 100%;
      }

      .swiper-slide {
        position: relative;
        text-align: center;
        font-size: 18px;
        background: #fff;
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        user-select: none;
      }

      .swiper-slide img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        cursor: pointer;
      }

      .swiper {
        width: 100%;
        height: 300px;
        margin-left: 0;
        margin-right: 0;
      }

      .swiper-slide {
        background-size: cover;
        background-position: center;
      }

      .gallery-swiper {
        height: 100%;
        width: 100%;
      }

      .gallery-swiper--thumb {
        box-sizing: border-box;
        height: 100%;
        width: 100%;
      }

      .gallery-swiper--thumb .swiper-slide {
        height: 100%;
        border: 5px solid transparent;
        border-radius: 8px;
        overflow: hidden;
        transition: border-color 0.2s ease-in-out;
        opacity: 1;

        img,
        video {
          border-radius: initial;
        }
      }

      .gallery-swiper--thumb .swiper-slide-thumb-active {
        border-color: #4ea6ec;
      }

      .swiper-slide img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .title {
        font-weight: 700;
        font-size: 36px;
        line-height: 32px;
        color: #3d424a;
        margin-top: 0;
      }

      .q-carousel__navigation-inner {
        flex-direction: column;
      }

      .q-carousel {
        background-color: #fff;
        height: 468px;
      }

      .gallery-carusel-wrp {
        display: flex;
        gap: 16px;
      }

      .panorama-wrp {
        .panorama-item {
          border-radius: 8px;
          border: none;
        }
      }

      .img-wrp {
        width: 850px;
        height: 468px;
      }

      .img-control {
        height: 468px;
      }

      .gallery-video-wrp {
        width: 850px;
      }

      .gallery-video-control {
        flex-direction: column;
      }

      .img-control {
        flex-direction: column;
      }

      .spinner {
        position: absolute;
        top: 30%;
        left: 38%;
        z-index: -1;

        &_bs {
          top: 45%;
          left: 45%;
          z-index: -1;
        }
      }

      .item-img {
        border-radius: 8px;
      }

      .item-video {
        padding: 0 !important;

        .gallery-video-loop {
          width: 100%;
          height: 100%;

          border-radius: 8px;
        }
      }

      .control-item {
        border-radius: 8px;
        max-width: 130px;
        padding-left: 5px;
      }

      .text {
        font-weight: 400;
        line-height: 140%;
        letter-spacing: 0.02em;
        color: #64686e;
        //max-width: 350px;
        max-width: 550px;
        margin-bottom: 30px;
        text-align: var(--var-text-align-left);
        font-size: 16px;

        .sub-text {
          font-weight: 400;
          font-size: 16px;
          color: #64686e;
          margin-top: 16px;
          margin-bottom: 0;
        }

        p {
          margin-top: 4px;
          font-size: 14px;
          line-height: 20px;
          color: #839aaf;
        }
      }

      .gallery-tabs-item {
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
      }

      .sub-gallery-tabs-item {
        font-weight: 700;
        font-size: 18px;

        .gallery-tabs-item {
          .q-tab:hover {
            background-color: white;
            color: white;
            transition: none;
          }
        }

        .q-tab__label:hover {
          color: #839aaf;
        }
      }

      .sub-gallery-tabs-item_active {
        .q-tab__indicator {
          background: transparent;
        }

        .q-tab__label:hover {
          color: $primary !important;
        }
      }
    }

    .q-tab-panel {
      padding: 24px 0;

      .q-tabs__content {
        .q-tab {
          padding: 0;
          margin-right: 32px;
        }
      }
    }

    .sub-panels {
      .q-tab-panel {
        padding: 0;

        .gallery-video-wrp {
          height: 500px;

          .q-carousel {
            height: 100%;
          }
        }
      }
    }

    .q-tab__label {
      font-weight: 700;
      font-size: 18px;
      color: #b2c0cd;
    }

    .q-tab--active {
      .q-tab__label {
        font-weight: 700;
        font-size: 18px;
        color: $primary;
      }

      .q-tab__label:hover {
        color: $primary;
      }
    }

    .m-section_1__wrp {
      display: none;
    }

    .text-primary {
      img {
        padding: 0 !important;
        //border: 5px solid $primary;
      }

      .control-item {
        padding: 0 !important;
        border: 5px solid #4ea6ec;
      }
    }

    @media (max-width: $lg) {
      .section_1 {
        .img-wrp {
          width: 100%;
          height: 328px;
        }

        .img-control {
          height: 100%;
        }

        .gallery-carusel-wrp {
          flex-direction: column;
        }

        .gallery-video-wrp {
          width: 100%;
        }
      }
      // .title {
      //   //padding-right: 20px;
      //   //padding-left: 20px;
      // }
      .m-section_1__wrp {
        display: block;
      }

      .m-img__item {
        padding: 20px;
        border-radius: 28px;
      }
      .m-title {
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
        letter-spacing: 0.03em;
        color: $primary;
        padding: 24px 20px 8px;
      }

      .m-select {
        margin-right: 20px;
        margin-left: 20px;
      }
      .m-modal__wrp {
        width: 100%;
      }
      .ui-tabs.ui-tabs--simple {
        .ui-tabs__nav {
          gap: 24px;
          font-size: 16px;
          margin-bottom: 12px;
        }
      }
    }

    @media (max-width: 900px) {
      .gallery-carusel-wrp {
        .panorama-wrp {
          .panorama-item {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
